import client from './client';

export interface ScheduledTask {
  task_key: string;
  name: string;
  enabled: boolean;
  interval_minutes: number;
  next_run_at: string | null;
  last_started_at: string | null;
  last_finished_at: string | null;
  last_status: 'never' | 'running' | 'success' | 'failed';
  last_error: string;
}

export interface ScheduledTaskRun {
  id: number;
  task_key: string;
  trigger_type: 'scheduled' | 'manual';
  status: 'running' | 'success' | 'failed';
  checked_count: number;
  changed_count: number;
  error_message: string;
  started_at: string;
  finished_at: string | null;
}

export const listScheduledTasks = async (): Promise<ScheduledTask[]> => (await client.get('/api/scheduled-tasks')).data;
export const updateScheduledTask = async (task: ScheduledTask): Promise<void> => { await client.put(`/api/scheduled-tasks/${task.task_key}`, { enabled: task.enabled, interval_minutes: task.interval_minutes }); };
export const runScheduledTask = async (key: string) => (await client.post(`/api/scheduled-tasks/${key}/run`)).data;
export const listScheduledTaskRuns = async (): Promise<ScheduledTaskRun[]> => (await client.get('/api/scheduled-task-runs')).data;
